<template>
	<modal
		class="panel-activity p-0"
		:show="showModal"
		:show-content="showContent"
		:page-title="modalTitle"
		:close-btn="closeBtn"
		:position="position"
		:size="size"
		@close="closeModal"
	>
		<template #content>
			<div class="ct-aside-control-item">
				<div class="ct-aside-control-header">
					<div class="title d-flex justify-content-between align-items-center w-100">
						{{ modalTitle }}
						<span v-if="reloadBtn" class="cursor-pointer">
							<i class="fas fa-repeat repeat-icon" @click.prevent="reloadData" ></i>
						</span>
					</div>
				</div>
				<div class="ct-aside-control-body">
					<div class="row no-gutters">
						<div class="col">
						<div class="row no-gutters form-group btn-group-toggle-city main">
							<div
							v-for="(btn, idx) in toggles"
							:key="idx"
							class="col-6"
							:for="'status-'+btn.id"
							>
							<label class="btn btn-block z-depth-0" :class="{'active': btn.id == selectedKey}">
								<input
									:id="'status-'+btn.id"
									v-model="selectedKey"
									type="radio"
									name="toogle-status"
									:value="btn.id"
									autocomplete="off">
								<span class="">{{ $t(btn.name) }}</span>
							</label>
							</div>
						</div>
						<div class="row no-gutters">
							<div class="col">
								<template v-if="hasActivitys">
									<ItemMap
										v-for="(item, idx) in selectedActivity"
										:key="`activity-${idx}`"
										:item="item"
										:txtLinkMap="`${idPanel}.item.link_map`"
										:labelCode="`${idPanel}.item.code`"
										:labelFeature="`${idPanel}.item.feature`"
										:labelDescription="`${idPanel}.item.description`"
										:labelAddress="`${idPanel}.item.address`"
										:labelCreatedAt="`${idPanel}.item.created_at`"
										@selectItem="onSelectItem"
									/>
								</template>
								<div v-else class="card">
									<div class="card-body">
										<p class="subtitle text-center">
											{{ txtNoRecords }}
										</p>
									</div>
								</div>
							</div>
						</div>
						</div>
					</div>
				</div>
			</div>
		</template>
	</modal>
</template>

<script type="text/javascript">
	import PanelMap from '@/app/shared/mixins/parts/PanelMap';
	import { isArray } from "@config/utils";

	export default {
		name: 'PanelMapActivity',
		components: {
			ItemMap: () => import(/* webpackChunkName: "card-item-map" */ './components/CardItemMap'),
		},
		mixins: [
			PanelMap
		],
		props: {
			position: {
				type: String,
				default: 'right',
			},
			size: {
				type: String,
				default: '',
			},
			toggles: {
				type: Array,
				default: () => []
			},
			eventCreated: {
                type: String,
                default: null
            },
            eventUpdated: {
                type: String,
                default: null
            },
            eventDeleted: {
                type: String,
                default: null
            },
			eventsReload: {
				type: [String, Array],
				default: () => ['map.reload', 'map.reload-activity']
			},
			hasConfirmation: {
				type: Boolean,
				default: true
			},
			propIdPanel: {
				type: String,
				default: 'activity'
			},
		},
		data() {
			return {
				idPanel: this.propIdPanel,
				showContent: true,
				activity: [],
				config: {},
				selectedKey: null,
			}
		},
		created() {
			this.setEvents(true);
		},
		beforeDestroy() {
			this.setEvents(false);
		},
		mounted() {
			this.selectedKey = this.toggles.length>0?this.toggles[0].id : null;
			this.initialize();
		},
		computed: {
			hasToggle() {
				return this.toggles.length > 0;
			},
			hasActivitys() {
				return this.selectedActivity.length > 0;
			},
			selectedCategory () {
				if(!this.selectedKey) return { key: null };
				return this.toggles.find(item => this.selectedKey == item.id);
			},
			selectedActivity() {
				if(!this.selectedCategory || this.activity.length <= 0) return [];
				return this.activity[this.selectedCategory.key].filter(item => !!item.status);
			},
			summaryActivity() {
				let summary = [];
				for(let i = 0; i < this.toggles.length; i++){
					const toggle = this.toggles[i];
					const data = this.activity[toggle.key];
					summary.push({
						name: toggle.name,
						num: data ? data.length : 0,
						titleTemplate: this.titleTemplate
					});
				}
				return summary;
			},
		},
		methods: {
			setEvents(flag) {
				if(flag) {
					// reload
					if(this.eventsReload) {
						this.addEventListen(this.moduleCode, this.eventsReload, this.loadData);
					}

					if(this.eventCreated) {
						this.addEventListen(this.moduleCode, this.eventCreated, this.onEntityCreated);
					}
					if(this.eventUpdated) {
						this.addEventListen(this.moduleCode, this.eventUpdated, this.onEntityUpdated);
					}
					if(this.eventDeleted) {
						this.addEventListen(this.moduleCode, this.eventDeleted, this.onEntityDeleted);
					}
				}else{
					if(this.eventsReload) {
						this.removeEventListen(this.moduleCode, this.eventsReload, this.loadData);
					}

					if(this.eventCreated) {
						this.removeEventListen(this.moduleCode, this.eventCreated, this.onEntityCreated);
					}
					if(this.eventUpdated) {
						this.removeEventListen(this.moduleCode, this.eventUpdated, this.onEntityUpdated);
					}
					if(this.eventDeleted) {
						this.removeEventListen(this.moduleCode, this.eventDeleted, this.onEntityDeleted);
					}
				}
			},
			onSelectItem: function(item) {
				this.$emit('selectFeature', item);
			},
			async loadData() {
				this.reset();
				await this.$http.get(this.url).then(({data}) => {
					this.config = data?.data?.config ?? {};
					delete data.data;
					this.activity = data;
					this.loaded = true;
				})
				.catch(error => {
					this.showHttpError(error);
				})
			},
			onEntityCreated(params) {
				this.updateFeatureFromEvent(params, 'created');
			},
			onEntityUpdated(params) {
				this.updateFeatureFromEvent(params, 'updated');
			},
			onEntityDeleted(params) {
				this.updateFeatureFromEvent(params, 'deleted');
			},
			updateFeatureFromEvent(params, eventType) {
				const {model_id = null, model = {}} = params;
				let config = this.config ?? {};
				let modelToggleKey = eventType.toLowerCase() =='deleted' ?
					null
					: Object.keys(config).find(key => {
						let _toggleConfig = config[key];
						let _property = _toggleConfig.property;
						let _values = _toggleConfig.values ?? [];
						_values = isArray(_values) ? _values : [_values];
						if(_property in model) {
							let val = model[_property];
							return _values.includes('*') || _values.includes(val);
						}
						return false;
					});

				// força a remover caso exista nos outros toggles
				// tem de remover primeiro, caso atualiza e origina erros quando o estado se altera
				Object.keys(this.activity)
				.filter(x => x != modelToggleKey)
				.forEach(key => {
					let _data = this.activity[key] ?? [];
					let _itemIdx = _data.findIndex(item => item.id == model_id);
					if(_itemIdx > -1) {
						_data.splice(_itemIdx, 1);
					}
				});

				if(modelToggleKey && modelToggleKey in this.activity) {
					let _data = this.activity[modelToggleKey];
					let _item = _data.find(item => item.id == model_id);
					if(_item) { // se existir, atualiza
						Object.assign(_item, this.pickDataFromObj(model, Object.keys(_item)));
					}else{ // adiciona
						let _itemRef = _data.length ? _data[0] : null;
						let _newObj = Object.assign({}, _itemRef ? this.pickDataFromObj(model, Object.keys(_itemRef)) : model);
						_data.unshift(_newObj);
					}
				}

			},
			dispatchPanel() {
				this.$store.dispatch(`${this.moduleCode}/setPanel`, {
					id: this.idPanel,
					loaded: true,
					summary: this.summaryActivity,
					reload: false,
				});
			},
			pickDataFromObj(obj, keys) {
				const newObj = keys.reduce((result, key) => {
					if (obj.hasOwnProperty(key)) {
						result[key] = obj[key];
					}
					return result;
				}, {});
				return newObj;
			},
		},
		watch: {
			'summaryActivity': {
				deep: true,
				handler: function(newValue, oldValue) {
					this.dispatchPanel();
				}
			}
		}
	}
</script>
